import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import { withStyles, createStyles } from '@material-ui/core';
import React from 'react';
var backgroundMasker = {
  background: '#f5f5f5',
  position: 'absolute',
  boxSizing: 'border-box'
};
var styles = createStyles({
  root: {
    animationName: '$fadeInQuickly',
    animationFillMode: 'forwards',
    animationDuration: '1s'
  },
  '@keyframes fadeInQuickly': {
    '0%': {
      opacity: 0
    },
    '50%': {
      opacity: 1
    },
    '100%': {
      opacity: 1
    }
  },
  gridGalleryElement: {
    position: 'absolute',
    marginLeft: 2,
    marginTop: 2,
    top: 20,
    transform: 'translateY(-50%)',
    maxHeight: '95%',
    maxWidth: '98%'
  },
  animatedBackground: {
    animationDuration: '1s',
    animationFillMode: 'both',
    animationIterationCount: 'infinite',
    animationName: '$placeHolderShimmer',
    animationTimingFunction: 'ease-in-out',
    background: 'linear-gradient(to right, #ffffff 8%, #dddddd 18%, #ffffff 33%)',
    backgroundSize: '800px 104px',
    width: '85%',
    left: '7.5%',
    height: 96,
    top: 10,
    position: 'absolute'
  },
  headerTop: _objectSpread({}, backgroundMasker, {
    top: 0,
    left: 40,
    right: 0,
    height: 10
  }),
  headerBottom: _objectSpread({}, backgroundMasker, {
    top: 18,
    left: 40,
    right: 0,
    height: 6
  }),
  headerLeft: _objectSpread({}, backgroundMasker, {
    top: 10,
    left: 40,
    height: 8,
    width: 10
  }),
  subheaderBottom: _objectSpread({}, backgroundMasker, {
    top: 30,
    left: 40,
    right: 0,
    height: 10
  }),
  subheaderLeft: _objectSpread({}, backgroundMasker, {
    top: 24,
    left: 40,
    height: 6,
    width: 10
  }),
  contentTop: _objectSpread({}, backgroundMasker, {
    top: 40,
    left: 0,
    right: 0,
    height: 20
  }),
  contentSecondLine: _objectSpread({}, backgroundMasker, {
    top: 68,
    left: 0,
    right: 0,
    height: 6
  }),
  contentThirdLine: _objectSpread({}, backgroundMasker, {
    top: 82,
    left: 0,
    right: 0,
    height: 6
  }),
  '@media (max-width: 938px)': {
    gridGalleryElement: {
      maxHeight: 163,
      maxWidth: 134
    }
  },
  '@keyframes placeHolderShimmer': {
    '0%': {
      backgroundPosition: [-468, 0]
    },
    '100%': {
      backgroundPosition: [468, 0]
    }
  }
});
/** 
  @param {import('@material-ui/core').WithStyles<typeof styles>}
*/

function ThumbLoadingAnimation(_ref) {
  var classes = _ref.classes;
  return React.createElement("div", {
    className: classes.root
  }, React.createElement("div", {
    className: classes.animatedBackground
  }, React.createElement("div", {
    className: classes.headerTop
  }), React.createElement("div", {
    className: classes.headerLeft
  }), React.createElement("div", {
    className: classes.headerBottom
  }), React.createElement("div", {
    className: classes.subheaderLeft
  }), React.createElement("div", {
    className: classes.subheaderBottom
  }), React.createElement("div", {
    className: classes.contentTop
  }), React.createElement("div", {
    className: classes.contentSecondLine
  }), React.createElement("div", {
    className: classes.contentThirdLine
  })));
}

export default withStyles(styles, {
  name: 'ECThumbLoadingAnimation'
})(ThumbLoadingAnimation);